import styled from "styled-components";

export const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  margin-top: 20px;
  margin-bottom: 16px;
`
